import { getTrackingDefaultPayload } from '../utils/getTrackingDefaultPayload';

export function scrollEvent() {
  const thresholds = [30, 60, 90];
  const triggered = new Set();
  let ticking = false;

  function checkScroll() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const docHeight = document.documentElement.scrollHeight;

    const scrollPercent = ((scrollTop + windowHeight) / docHeight) * 100;

    // Trouver le seuil le plus élevé atteint
    const highestThreshold = [...thresholds]
      .reverse()
      .find((percent) => scrollPercent >= percent);

    if (highestThreshold && !triggered.has(highestThreshold)) {
      const { title, ...defaultPayload } = getTrackingDefaultPayload();
      window.analytics?.track('scroll', {
        ...defaultPayload,
        pagename: title,
        scrollRate: highestThreshold,
      });

      triggered.add(highestThreshold);
    }

    ticking = false;
  }

  function handleScroll() {
    if (!ticking) {
      window.requestAnimationFrame(checkScroll);
      ticking = true;
    }
  }

  window.addEventListener('scroll', handleScroll);

  return function destroy() {
    window.removeEventListener('scroll', handleScroll);
  };
}
